import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

import { useAgentRefs } from '@/app/agentConversation/_context';
import { AGENT_KINDS, AGENT_TAB_LABELS } from '@/app/agentConversation/_enums';
import { isAgentTab, parseRef, pathForRef, refKey } from '@/app/agentConversation/_helpers';

import { Button } from '@/app/ui/button';

/**
 * Where the assistant suggests going, as a link the user clicks. Nothing moves
 * them on its own: a reply that opened pages as it streamed would pull the
 * screen away from whatever they were doing. A tab the record does not have
 * is dropped, and the link opens the record's first tab.
 */
const NavigateBlock = ({ block }) => {
  const refs = useAgentRefs();
  const refValue = parseRef(block.ref);
  if (!refValue) return null;

  const name = refs[refKey(refValue)]?.title || AGENT_KINDS[refValue.kind].label;
  const tab = isAgentTab(refValue.kind, block.tab) ? block.tab : undefined;
  const label = tab ? `${name} · ${AGENT_TAB_LABELS[refValue.kind][tab]}` : name;

  return (
    <Button variant="outline" size="sm" className="my-1.5 h-auto max-w-full justify-start py-1.5 text-left whitespace-normal" asChild>
      <Link to={pathForRef(refValue, tab)} data-testid="agent-navigate">
        <span className="min-w-0">Go to {label}</span>
        <ArrowRight />
      </Link>
    </Button>
  );
};

export default NavigateBlock;
